import * as StyleFunctions from '../utilities/StyleFunctions';
import React, { useEffect, useRef } from "react";

function App(props) {

  var isResponsive = props.isResponsive;
  var addClasses = props.addClasses;
  var allStyles = props.allStyles;
  var stylesToAdd = props.stylesToAdd;
  var covering = props.covering;
  var onMouseOver = props.onMouseOver;
  var onMouseOut = props.onMouseOut;
  var doAScreenRef = props.doAScreenRef;
  var itemPath = props.itemPath;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var vAddStuff = [];
  var insideS = {}
  var startVideoClassName = ''
  var insideVideoClassName = ''
  if (isResponsive){
    startVideoClassName = 'embed-responsive';
    vAddStuff = ['vDimensions'];
    insideVideoClassName = 'embed-responsive-item';
  }else{
    insideS = {width:'100%', height:'100%', position:'absolute', border:'none'};
  }

  var className5 = StyleFunctions.iterateClassNames(startVideoClassName + addClasses, vAddStuff, allStyles);
  // stylesToAdd.position = 'relative';

  return <div ref={ref1} className={className5} style={{...allStyles, ...stylesToAdd}} onMouseOver={onMouseOver} onMouseOut={onMouseOut}><iframe title='video' style={insideS} className={insideVideoClassName} src={'https://www.youtube.com/embed/'+allStyles.videoId}></iframe>{covering}</div>
//    
  // return <div key={itemInfoPathString} className={className5} style={{...allStyles, ...stylesToAdd}} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}><YouTube videoId={allStyles.videoId} opts={opts} onReady={onReady} />{covering}</div>
}
//




export default App;
